import './App.css'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Furlough from './page/furlough/furlough'
import Users from './page/user/users'
import Login from './page/login'
import FurloughGet from './page/furloughGet/furloughGet'
import FurloughGetAdd from './page/furlough/furloughAdd'
import UserAdd from './page/user/userAdd'
import SectionAdd from './page/sections/sectionAdd'
import FurloughGetView from './page/furloughGet/furloughGetView'
import UserEdit from './page/user/userEdit'
import SectionEdit from './page/sections/sectionEdit'
import FurloughView from './page/furlough/furloughView'
import Orders from './page/orders'
import Sections from './page/sections/sections'
import React, { createContext, useEffect, useState } from 'react'
import Dashboard from './page/dashboard'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import UserProfile from './page/user/userProfile'
import FurloughGetViewManagment from './page/furloughGetManagment/furloughGetViewManagment'
import FurloughGetManagment from './page/furloughGetManagment/furloughGetManagment'
import DepartmentLayoutWithProvider from './page/departmentLayout/DepartmentLayoutWithProvider'
import PositionLayoutWithProvider from './page/positionLayout/PositionLayoutWithProvider'
import Organization3LayoutWithProvider from './page/organization2Layout/Organization3LayoutWithProvider'
import FurloughRoutesAdd from './page/furloughRoutes/furloughRoutesAdd'
import FurloughRoutes from './page/furloughRoutes/furloughRoutes'
import FurloughRoutesEdit from './page/furloughRoutes/furloughRoutesEdit'
import Organization from './page/organizations/organizations'
import OrganizationEdit from './page/organizations/organizationEdit'
import OrganizationWorkingHoursEdit from './page/organizationsShift/organizationWorkingHoursEdit'
import RequestQueue from './api/requestQueue'
import SendAnonymousMessage from './page/anonymousMessage/sendAnonymousMessage'
import AnonymousMessage from './page/anonymousMessage/anonymousMessage'
import SendEmployeeIdea from './page/employeeIdea/sendEmployeeIdea'
import EmployeeIdeas from './page/employeeIdea/employeeIdeas'
import Reports from './page/reports/reports'
import OrganizationShift from './page/organizationsShift/organizationsShift'
import OrganizationShiftAdd from './page/organizationsShift/organizationShiftAdd'
import OrganizationShiftEdit from './page/organizationsShift/organizationShiftEdit'
import { canViewEmployeeIdeas } from './component/canViewEmployeeIdeas'
import { useAuthResult } from './hooks/useAuthResult'

export const AppContext = createContext()
export const AppContextMenu = createContext('dashboard')
function App() {
    const authResult = useAuthResult()
    const [isTrue, setIsTrue] = useState(false)

    const toggleValue = () => {
        setIsTrue(!isTrue)
    }

    const contextValues = {
        isTrue,
        toggleValue,
    }

    const [menu, setMenu] = useState('dashboard')

    const updateValue = (newValue) => {
        setMenu(newValue)
    }

    const appContextMenu = {
        menu,
        updateValue,
    }

    useEffect(() => {
        let user = JSON.parse(localStorage.getItem('authResult'))
        if (user !== null && user !== undefined && user) {
            getUser(JSON.parse(localStorage.getItem('authResult')))
        }
    }, [])

    const getUser = async (oldData) => {
        await RequestQueue.sendRequest({
            config: {
                method: 'get',
                url: `/user/${oldData.user.id}`,
            },
            resolve: (res) => {
                oldData.user = res.data
                RequestQueue.setAuthResult(oldData)
                localStorage.setItem('authResult', JSON.stringify(oldData))
            },
            reject: (error) => {},
        })
    }

    return (
        <AppContext.Provider value={contextValues}>
            <AppContextMenu.Provider value={appContextMenu}>
                <ToastContainer autoClose={3000} />
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Dashboard />} />
                        <Route
                            path="/furloughRoutesAdd"
                            element={<FurloughRoutesAdd />}
                        />
                        <Route
                            path="/furloughRoutesEdit/:id"
                            element={<FurloughRoutesEdit />}
                        />
                        {RequestQueue.getAuthResult()?.user?.role?.abilities
                            ?.furlough_routes && (
                            <Route
                                path="/furloughRoutes"
                                element={<FurloughRoutes />}
                            />
                        )}
                        {RequestQueue.getAuthResult()?.user?.role?.abilities
                            ?.dp_organizations && (
                            <Route
                                path="/organizationLayout"
                                element={<Organization3LayoutWithProvider />}
                            />
                        )}
                        <Route
                            path="/departmentLayout"
                            element={<DepartmentLayoutWithProvider />}
                        />
                        <Route
                            path="/positionLayout"
                            element={<PositionLayoutWithProvider />}
                        />
                        {RequestQueue.getAuthResult()?.user?.role?.abilities
                            ?.users && (
                            <Route path="/users" element={<Users />} />
                        )}
                        <Route path="/login" element={<Login />} />
                        <Route path="/furlough" element={<Furlough />} />
                        <Route
                            path="/furloughGet"
                            element={<FurloughGet />}
                        />{' '}
                        {RequestQueue.getAuthResult()?.user?.role?.abilities
                            ?.furlough_all && (
                            <Route
                                path="/furloughGetManagment"
                                element={<FurloughGetManagment />}
                            />
                        )}
                        <Route
                            path="/furloughAdd"
                            element={<FurloughGetAdd />}
                        />
                        <Route path="/userAdd" element={<UserAdd />} />
                        <Route path="/sectionAdd" element={<SectionAdd />} />
                        <Route
                            path="/furloughGetView/:id"
                            element={<FurloughGetView />}
                        />{' '}
                        <Route
                            path="/furloughGetViewManagment/:id"
                            element={<FurloughGetViewManagment />}
                        />
                        <Route path="/userEdit/:id" element={<UserEdit />} />
                        <Route
                            path="/sectionEdit/:id"
                            element={<SectionEdit />}
                        />
                        <Route
                            path="/organizationWorkingHoursEditEdit/:id/:name"
                            element={<OrganizationWorkingHoursEdit />}
                        />
                        {RequestQueue.getAuthResult()?.user?.role?.abilities
                            ?.organizations && (
                            <Route
                                path="/organization"
                                element={<Organization />}
                            />
                        )}
                        {RequestQueue.getAuthResult()?.user?.role?.abilities
                            ?.organizations && (
                            <Route
                                path="/organizationShift"
                                element={<OrganizationShift />}
                            />
                        )}
                        {RequestQueue.getAuthResult()?.user?.role?.abilities
                            ?.organizations && (
                            <Route
                                path="/organizationShiftAdd"
                                element={<OrganizationShiftAdd />}
                            />
                        )}
                        {RequestQueue.getAuthResult()?.user?.role?.abilities
                            ?.organizations && (
                            <Route
                                path="/organizationShiftEdit/:id"
                                element={<OrganizationShiftEdit />}
                            />
                        )}
                        <Route
                            path="/organizationEdit/:id"
                            element={<OrganizationEdit />}
                        />
                        <Route
                            path="/furloughView/:id"
                            element={<FurloughView />}
                        />
                        <Route path="/orders" element={<Orders />} />
                        {RequestQueue.getAuthResult()?.user?.role?.abilities
                            ?.userProfile && (
                            <Route
                                path="/userProfile"
                                element={<UserProfile />}
                            />
                        )}
                        <Route path="/sections" element={<Sections />} />
                        {RequestQueue.getAuthResult()?.user?.role?.abilities
                            ?.reports && (
                            <Route path="/reports" element={<Reports />} />
                        )}
                        <Route
                            path="/sendAnonymousMessage"
                            element={<SendAnonymousMessage />}
                        />
                        {RequestQueue.getAuthResult()?.user
                            ?.is_anonymous_message && (
                            <Route
                                path="/anonymousMessage"
                                element={<AnonymousMessage />}
                            />
                        )}
                        <Route
                            path="/sendEmployeeIdea"
                            element={<SendEmployeeIdea />}
                        />
                        {canViewEmployeeIdeas(authResult) && (
                            <Route
                                path="/employeeIdeas"
                                element={<EmployeeIdeas />}
                            />
                        )}
                    </Routes>
                </BrowserRouter>
            </AppContextMenu.Provider>
        </AppContext.Provider>
    )
}

export default App
